<template lang="pug">
app-modal(v-model="visible" :title="title" :width="1200" @ok="handleSubmit" @cancel="hide")
  div.inventory_editor.flex
    div.product_list.p1 下单产品列表
      app-custom-table.mt1(
        ref="table"
        :tableData="orignOrder.orderItems"
        :tableColumns="tableColumns"
        noPagination
        selectionMode="single"
      )
    div.inventory_list.p1 可用库存列表
      app-custom-table.mt1(
        ref="table"
        :tableData="orignOrder.orderItems"
        :tableColumns="tableColumns"
        noPagination
        selectionMode="single"
      )
    

    
</template>

<script>
import _ from 'lodash';

import { GETTER_PROJECT } from '@store/account';
import { mapGetters } from 'vuex';
export default {
  name: 'ProductSelect',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: [Array, Object],
    target: Object,
  },
  data() {
    return {
      visible: false,
      title: '选择库存',
      tableColumns: [],
      // columns: ['name', 'type', 'dept', 'enabled'],
      // 选中
      defaultSelections: [],
      // 筛选
      filters: { enabled: true },
      filterFieleds: [],
      // 数据拷贝
      orignOrder: {},
      // 产品列表
      productDTOS: [],
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
    }),
    params() {
      return {
        ...this.filters,
        projectId: this.project.id,
      };
    },
  },
  watch: {
    value: 'handleValueChange',
  },
  created() {
    this.initTableColumns();
    this.initFilters();
  },
  methods: {
    // 根据 value 改变选中项
    handleValueChange() {
      this.productDTOS = this.value || [];
    },
    show() {
      this.orignOrder = _.cloneDeep(this.target);
      this.handleValueChange();
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },

    handleSubmit() {
      const selectRows = this.$refs.table.selections || [];
      this.$emit('change', [...selectRows]);
      console.log('selectRows-----------------', selectRows);
      // this.$refs.table.selectedRowKeys = [];
      this.hide();
    },

    // 初始化表格 列
    initTableColumns() {
      this.tableColumns = [
        {
          uid: 'name',
          dataIndex: 'name',
          title: '产品名称',
          width: '150px',
          render(h, v, r) {
            return r.productDTO.name;
          },
        },

        {
          uid: 'quantity',
          dataIndex: 'quantity',
          title: '产品数量',
          width: '100px',
          // sorter: true,
        },
        // {
        //   uid: 'remark',
        //   dataIndex: 'remark',
        //   title: '备注',
        //   width: '100px',
        // },
      ];
    },
    // 初始化筛选条件
    initFilters() {
      this.filterFieleds = [];
    },
  },
};
</script>

<style lang="less" scoped>
.inventory_editor {
  width: 100%;
  gap: 16px;
  .product_list {
    flex: 1;
  }
  .inventory_list {
    flex: 1;
  }
}
</style>
